import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { SessionService } from 'src/app/shared/_service/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/shared/_service/product.service';
import { AuthService } from 'src/app/auth/_service/auth.service';

@Component({
	selector: 'app-category',
	templateUrl: './category.component.html',
})
export class CategoryComponent implements OnInit {
	constructor(
		private session: SessionService,
		private router: Router,
		private route: ActivatedRoute,
		private productService: ProductService,
		private auth: AuthService,
	) {}

	idNeutral = environment.idNeutral;
	ordineSerie = environment.ordineSerie;
	serieCategoria = environment.serieCategoria;
	user = this.auth.getUser();

	prodotti = [];
	prodottiVisualizzati = [];

	serieVisualizzate = [];

	// Filtri visualizzati
	famiglie = [];
	linee = [];
	colori = [];

	categoria = '';
	showColors = false;

	ngOnInit() {
		this.route.queryParams.subscribe((params) => {
			this.prodotti = [];
			this.prodottiVisualizzati = [];
			this.serieVisualizzate = [];
			this.famiglie = [];
			this.linee = [];
			this.colori = [];
			this.categoria = '';

			this.session.getProdotti().subscribe((prodotti) => {
				if (params.q) {
					this.categoria = params.q;

					this.prodotti = prodotti.filter((p) => p.tipo === params.q);
					this.prodotti.forEach(
						(p) => (p.prodottiCommerciali = p.prodottiCommerciali.sort((pc1, pc2) => (pc1.colore.ordine || 0) - (pc2.colore.ordine || 0))),
					);

					this.prodotti.forEach((p) => {
						p.selected = p.prodottiCommerciali[0];
						p.prodottiCommerciali.forEach((pc) => (pc.quantita = 1));
					});

					let prodottiLog = this.prodotti
						.map((p) => ({
							descrizioni: p.descrizioni,
							codiceCommerciale: p.prodottiCommerciali[0].codiceCommerciale,
							linea: p.lineaEstetica,
							immagini: p.prodottiCommerciali[0].immagini,
						}))
						.sort((a: any, b: any) => a.codiceCommerciale.localeCompare(b.codiceCommerciale));
					console.log('Prodotti prima:', JSON.parse(JSON.stringify(prodottiLog)));

					// Questo inserisce i filtri disponibili
					this.filtra();

					prodottiLog = this.prodottiVisualizzati
						.map((p) => ({
							descrizioni: p.descrizioni,
							codiceCommerciale: p.prodottiCommerciali[0].codiceCommerciale,
							linea: p.lineaEstetica,
							immagini: p.prodottiCommerciali[0].immagini,
						}))
						.sort((a: any, b: any) => a.codiceCommerciale.localeCompare(b.codiceCommerciale));
					console.log('Prodotti dopo:', JSON.parse(JSON.stringify(prodottiLog)));
				}

				console.log('Serie Visualizzate:', this.serieVisualizzate);
				console.log('Filtri:', 'Linea estetica:', this.linee, 'Tipo:', this.famiglie, 'Colori:', this.colori);
			});
		});
	}

	getDescrizione(prodotto) {
		return (
			prodotto.selected.descrizioni.find((d) => d.lingua.codice === 'US') || prodotto.descrizioni.find((d) => d.lingua.codice === 'US')
		);
	}

	stepQuantita(mode, prodottoCommerciale) {
		if (prodottoCommerciale) {
			if (prodottoCommerciale.quantita > 0 && mode === '-') {
				prodottoCommerciale.quantita--;
			}
			if (
				prodottoCommerciale.quantita < 100 &&
				mode === '+' &&
				!(prodottoCommerciale.statoGiacenza === 'IN_STOCK' && prodottoCommerciale.giacenza <= prodottoCommerciale.quantita)
			) {
				prodottoCommerciale.quantita++;
			}
		}
	}

	buy({ codiceTecnico, quantita }) {
		this.session.setCarrello(codiceTecnico, quantita, true).subscribe(() => this.router.navigate(['/cart']));
	}

	reset() {
		this.famiglie.forEach((f) => {
			f.selected = false;
		});
		this.linee.forEach((l) => {
			l.selected = false;
		});
		this.colori.forEach((c) => {
			c.selected = false;
		});
		this.showColors = false;
		this.filtra();
	}

	/**
	 *  filtra()
	 *  Esegue i filtri in pagina e inserisce tutti i prodotti dividendoli per serie o categoria
	 *  @param filtro -> Il filtro: un oggetto di this.famiglie o this.linee o this.colori
	 *  @param valore -> Se il filtro é selezionato o meno Boolean
	 */
	filtra(filtro?, value?) {
		// Se deseleziono il primo filtro resetto lo stato in pagina;
		if (filtro && filtro.tipo === 'LINEA' && !value) {
			this.reset();
		}

		// De\Seleziono il filtro e riporto lo stato a: nessun filtro selezionato, per ri-applicare i filtri attivati
		if (filtro) {
			filtro.selected = value;
		}
		this.prodottiVisualizzati = this.prodotti;

		// Applico le logiche dei prodotti neutral per copiarli nelle varie linee, questo metodo inserisce anche tutti i filtri linea estetica (schiantati)
		this.copiaProdottiNeutral();

		// Aggiorno o aggiungo i filtri visualizzati
		this.prodottiVisualizzati.forEach((p) => {
			if (!this.famiglie.find((f) => f.valore === p.famiglia)) {
				this.famiglie.push({ valore: p.famiglia });
			}
		});
		this.prodottiVisualizzati.forEach((p) => {
			if (!this.linee.find((f) => f.valore === p.lineaEstetica)) {
				this.linee.push({ valore: p.lineaEstetica, tipo: 'LINEA' });
			}
		});
		this.prodottiVisualizzati.forEach((p) =>
			p.prodottiCommerciali.forEach((pc) => {
				if (!this.colori.find((c) => c.valore === pc.colore.idBertazzoni)) {
					this.colori.push({ valore: pc.colore.idBertazzoni, codiceHtml: pc.colore.codiceHtml, ordine: pc.colore.ordine });
				}
			}),
		);
		this.colori = this.colori.sort((c1, c2) => (c1.ordine || 0) - (c2.ordine || 0));

		// Se dopo aver copiato i prodotti neutral ( e aggiunto tutte le linee ) una linea non produce nessun risultato ( non ci sono prodotti di quella linea prima dei filtri ) la rimuovo
		this.linee.forEach((l) => {
			if (!this.prodottiVisualizzati.find((p) => p.lineaEstetica === l.valore)) {
				this.linee.splice(this.linee.indexOf(l), 1);
			}
		});

		// Filtro i prodotti per famiglia
		const famiglieDeselezionati = this.famiglie.filter((f) => !f.selected);
		if (famiglieDeselezionati.length < this.famiglie.length) {
			famiglieDeselezionati.forEach(
				({ valore }) => (this.prodottiVisualizzati = this.prodottiVisualizzati.filter((p) => p.famiglia !== valore)),
			);
		}

		// Filtro i prodotti per linea estetica
		const lineeDeselezionati = this.linee.filter((f) => !f.selected);
		if (lineeDeselezionati.length < this.linee.length) {
			lineeDeselezionati.forEach(
				({ valore }) => (this.prodottiVisualizzati = this.prodottiVisualizzati.filter((p) => p.lineaEstetica !== valore)),
			);
		}

		// Filtro i prodotti per colore
		const coloriSelezionati = this.colori.filter((c) => c.selected);
		if (coloriSelezionati.length > 0) {
			let prodottiVisualizzatiPreFiltroColore = this.prodottiVisualizzati;
			this.prodottiVisualizzati = [];
			coloriSelezionati.forEach(({ valore }) => {
				// Cerco i prodotti con quel colore
				const prodottiConColore = prodottiVisualizzatiPreFiltroColore.filter((p) =>
					p.prodottiCommerciali.find((pc) => pc.colore.idBertazzoni === valore),
				);
				// Tolgo dai prodotti da filtrare quelli che sto per aggiungere
				prodottiVisualizzatiPreFiltroColore = prodottiVisualizzatiPreFiltroColore.filter((x) => !prodottiConColore.includes(x));
				this.prodottiVisualizzati = this.prodottiVisualizzati.concat(prodottiConColore);
			});
		}

		// Riabilito tutti i filtri
		this.famiglie.forEach((f) => (f.disabled = false));
		this.linee.forEach((l) => (l.disabled = false));
		this.colori.forEach((f) => (f.disabled = false));

		// Disabilito i filtri che non producono risultati
		this.famiglie.forEach((f) => {
			if (!this.prodottiVisualizzati.find((p) => p.famiglia === f.valore)) {
				f.disabled = true;
			}
		});
		this.linee.forEach((l) => {
			if (!this.prodottiVisualizzati.find((p) => p.lineaEstetica === l.valore)) {
				l.disabled = true;
			}
		});
		this.colori.forEach((f) => {
			if (!this.prodottiVisualizzati.find((p) => p.prodottiCommerciali.find((pc) => pc.colore.idBertazzoni === f.valore))) {
				f.disabled = true;
			}
		});

		// Popolo le linee
		this.serieVisualizzate = [];
		this.linee
			.filter((l) => !l.disabled)
			.forEach((l) => {
				if (this.productService.isSeriePresente(l.valore)) {
				}
				this.serieVisualizzate.push({ nome: l.valore, prodotti: this.prodottiVisualizzati.filter((p) => p.lineaEstetica === l.valore) });
			});

		// Rimuovo serie e filtro neutral
		const serieNeutral = this.serieVisualizzate.find((s) => this.idNeutral.includes(s.nome));
		if (serieNeutral) {
			this.serieVisualizzate.splice(this.serieVisualizzate.indexOf(serieNeutral), 1);
		}
		const filtroNeutral = this.linee.find((l) => this.idNeutral.includes(l.valore));
		if (filtroNeutral) {
			this.linee.splice(this.linee.indexOf(filtroNeutral), 1);
		}

		// Filtro tutte le serie che non sono presenti tra i prodotti a listino dell'utente

		// Applico l'ordinamento delle serie nei filtri e nei risultati (schianato)
		this.ordinaSerie();
	}

	// Aggiungo i prodotti neutral camuffandoli come altre categorie
	copiaProdottiNeutral() {
		// Pesco i prodotti che hanno linea estetica neutral
		const prodottiNeutral = this.productService.filtraProdottiNeutral(this.prodottiVisualizzati);

		// In serieVisualizzate sono presenti solamente le linee estetiche contenute nei prodotti filtrati
		// Nel caso di un prodotto neutral devo copiarle in tutte e 3 le serie quindi devo aggiungere le linee estetiche mancanti ( serie = linea estetica )
		this.serieCategoria.forEach((sc) => {
			// Controllo che la serie schiantata che sto analizzando non sia presente tra le linee attualmente censite (ovvero quelle dei prodotti non neutral attualmente in memoria)
			if (!this.linee.find((l) => sc.find((x) => x.serie === l.valore) != null)) {
				const listaCodiciSerie = sc.map((ass) => ass.serie).join(',');
				// Cerco la linea estetica mancante corrispondente alla categoria
				const associazione = sc.find((x) => x.categoria === this.categoria);
				if (associazione && this.productService.isSeriePresente(listaCodiciSerie)) {
					this.serieVisualizzate.push({ nome: associazione.serie });
					this.linee.push({ valore: associazione.serie, tipo: 'LINEA' });
				} else {
					console.log('Associazione serie-categoria non trovata per ' + this.categoria + ' in: ', sc);
				}
			}
		});

		if (prodottiNeutral.length === 0) {
			return;
		}

		// Per ogni Linea estetica copio i prodotti
		this.linee.forEach((lineaEstetica) => {
			let prodottiNeutralCopy = JSON.parse(JSON.stringify(prodottiNeutral));
			prodottiNeutralCopy.forEach((prodottoNeutral) => {
				prodottoNeutral.lineaEstetica = lineaEstetica.valore;
				prodottoNeutral.isNeutral = true;

				// Applico la logica di divisione nelle serie in base a quante immagini contiene il prodotto neutral
				// 0 immagini -> Copio solo in professional e master se la categoria e' cappe, forni o piani, altrimenti in tutte e 3
				// 1 immagine -> Copio solo in professional e master se la categoria e' cappe, forni o piani, altrimenti in tutte e 3
				// 2 immagini -> Copio solo nelle linee indicate dal campo lineaEstetica dell' oggetto immagine e applico l'immagine giusta per la serie
				// 3 immagini -> Copio in tutte e 3 le serie scegliendo l'immagine giusta
				prodottoNeutral.prodottiCommerciali.forEach((pc) => {
					// Caso 0 o 1 immagine -> Copio su tutte e 3 le serie solo se il prodotto é diverso da cappe, forni o piani
					if (pc.immagini.length === 1 || pc.immagini.length === 0) {
						// Se non posso copiare in neutral svuoto i prodotti commerciali
						if (!this.productService.condizioneCopiaNeutral(prodottoNeutral, lineaEstetica.valore)) {
							prodottoNeutral.prodottiCommerciali = [];
						}
					}
					// Caso 2 o 3 immagini -> Scelgo immagine giusta (1) e rimuovo se non trovo l'immagine corrispondente (2)
					if (pc.immagini.length >= 2) {
						const immagineDellaSerie = pc.immagini.find((i) => prodottoNeutral.lineaEstetica === i.lineaEstetica);
						pc.immagini = immagineDellaSerie ? [immagineDellaSerie] : []; // 1
						if (!immagineDellaSerie) {
							// Se non trovo l'immagine é una delle 3 serie in cui non dev'essere visualizzato, lo rimuovo
							prodottoNeutral.prodottiCommerciali.splice(prodottoNeutral.prodottiCommerciali.indexOf(pc), 1); // 2
						}
					}
				});
				prodottoNeutral.selected = prodottoNeutral.prodottiCommerciali[0];
			});

			// Se un prodotto neutral non deve essere visualizzato i suoi prodtti commerciali sono vuoti quindi li filtro
			prodottiNeutralCopy = prodottiNeutralCopy.filter((p) => p.prodottiCommerciali.length > 0);
			this.prodottiVisualizzati = this.prodottiVisualizzati.concat(prodottiNeutralCopy);
		});
	}

	ordinaSerie() {
		this.serieVisualizzate = this.serieVisualizzate.sort((s1, s2) => {
			const s1ordine = this.ordineSerie.find((x) => x.nome.split(';').includes(s1.nome));
			const s2ordine = this.ordineSerie.find((x) => x.nome.split(';').includes(s2.nome));
			if (s1ordine && s2ordine) {
				return s1ordine.ordine - s2ordine.ordine;
			}
			return 0;
		});

		this.serieVisualizzate.forEach((s) => {
			s.prodotti = s.prodotti.sort((p1, p2) =>
				p2.prodottiCommerciali[0].codiceCommerciale.localeCompare(p1.prodottiCommerciali[0].codiceCommerciale),
			);
		});

		this.linee = this.linee.sort((s1, s2) => {
			const s1ordine = this.ordineSerie.find((x) => x.nome.split(';').includes(s1.valore));
			const s2ordine = this.ordineSerie.find((x) => x.nome.split(';').includes(s2.valore));
			if (s1ordine && s2ordine) {
				return s1ordine.ordine - s2ordine.ordine;
			}
			return 0;
		});
	}

	isNew(prodotto) {
		const date = moment(prodotto.dataCreazione, 'dd/MM/yyyy');
		return moment().diff(date, 'months', true) < 3;
	}

	get lineaSelezionata() {
		return this.linee.find((t) => t.selected);
	}
}
